import React, { useEffect, useState } from 'react';
import Head from '../Header/Head';
import Header from '../Header/Header';
import ArticleNav from '../Post/Article/ArticleNav';
import AuthorProfileHeader from './AuthorProfileHeader';
import { getUser } from '../../helpers/token';

const AuthorProfile = props => {
  const [isMember, setIsMember] = useState(false);

  useEffect(() => {
    if (getUser()) setIsMember(true);
  }, []);

  // Warm paper behind everything — same as the post page (SinglePost.js).
  // Without it the gray body bg flashes through while client queries load.
  useEffect(() => {
    document.body.classList.add('tf-paper');
    return () => document.body.classList.remove('tf-paper');
  }, []);

  // eslint-disable-next-line one-var
  let displayName = props.username;
  let { username } = props;
  let coverImage;
  let about;
  let roles;
  let avatar;
  if (props.profile && props.profile.author) {
    coverImage = props.profile.coverImage;
    about = props.profile.about;
    displayName = props.profile.author.displayName;
    roles = props.profile.author.roles;
    username = props.profile.author.username;
    avatar = props.profile.author.avatar;
  }

  return (
    <>
      <Head
        shorttitle={`${displayName}'s Travel Blog`}
        image={coverImage}
        description={`${displayName}'s Travel Blog: ${about}`}
        profile={props.profile}
        includeMapbox
        feedUrl={`@${username}`}
        noIndex={!props.profile.isIndex}
        noFollow={!props.profile.isIndex}
      />
      {isMember ? (
        <Header active="blog" subheader={displayName} author={username} />
      ) : (
        <ArticleNav />
      )}
      <AuthorProfileHeader
        data={{
          name: username,
          displayName,
          isBlacklisted: roles && roles.indexOf('blacklist') !== -1,
          isCurator: roles && roles.indexOf('team') !== -1,
          isVideo: roles && roles.indexOf('video') !== -1,
          isPaid: roles && roles.indexOf('paid') !== -1,
          coverImage,
          profileImage: avatar,
        }}
        profile={props.profile}
      />
    </>
  );
};

export default AuthorProfile;
